export default __webpack_public_path__ + "static/media/etapa-2.8adeff00.png";